var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashInSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08333 10.4211C2.82686 10.4211 1.81481 11.4461 1.81481 12.7025V23.2803C1.81481 24.5367 2.82685 25.5618 4.08333 25.5618H23.9167C25.1731 25.5618 26.1852 24.5367 26.1852 23.2803V12.7025C26.1852 11.4461 25.1731 10.4211 23.9167 10.4211H19.8333C19.479 10.4211 19.1852 10.1306 19.1852 9.76427C19.1852 9.39792 19.479 9.10748 19.8333 9.10748H23.9167C25.8819 9.10748 27.4815 10.7134 27.4815 12.7025V23.2803C27.4815 25.2694 25.8819 26.8754 23.9167 26.8754H4.08333C2.11814 26.8754 0.518519 25.2694 0.518519 23.2803V12.7025C0.518519 10.7134 2.11814 9.10748 4.08333 9.10748H8.16667C8.52102 9.10748 8.81482 9.39792 8.81482 9.76427C8.81482 10.1306 8.52102 10.4211 8.16667 10.4211H4.08333ZM14 15.1223C12.4213 15.1223 11.1481 16.4104 11.1481 17.9914C11.1481 19.5724 12.4213 20.8606 14 20.8606C15.5787 20.8606 16.8519 19.5724 16.8519 17.9914C16.8519 16.4104 15.5787 15.1223 14 15.1223ZM9.85185 17.9914C9.85185 15.6778 11.7126 13.8087 14 13.8087C16.2873 13.8087 18.1481 15.6778 18.1481 17.9914C18.1481 20.305 16.2873 22.1741 14 22.1741C11.7126 22.1741 9.85185 20.305 9.85185 17.9914ZM5.83333 14.984C6.1877 14.984 6.48148 15.2744 6.48148 15.6408V20.342C6.48148 20.7084 6.1877 20.9988 5.83333 20.9988C5.47897 20.9988 5.18519 20.7084 5.18519 20.342V15.6408C5.18519 15.2744 5.47897 14.984 5.83333 14.984ZM22.1667 14.984C22.521 14.984 22.8148 15.2744 22.8148 15.6408V20.342C22.8148 20.7084 22.521 20.9988 22.1667 20.9988C21.8123 20.9988 21.5185 20.7084 21.5185 20.342V15.6408C21.5185 15.2744 21.8123 14.984 22.1667 14.984ZM2.33459 12.6351C2.36977 11.6927 3.13924 10.9396 4.08333 10.9396H8.16667C8.81099 10.9396 9.33333 10.4134 9.33333 9.76427C9.33333 9.11517 8.81099 8.58896 8.16667 8.58896H4.08333C1.82817 8.58896 0 10.4307 0 12.7025V12.7024C0 10.4306 1.82817 8.58887 4.08333 8.58887H8.16667C8.81099 8.58887 9.33333 9.11508 9.33333 9.76418C9.33333 10.4133 8.81099 10.9395 8.16667 10.9395H4.08333C3.13921 10.9395 2.36972 11.6927 2.33459 12.6351Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_777_8587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8906 7.5L14.0017 10.8333L10.1128 7.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5001L14 3.16675",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_777_8587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(20.668 2.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashInSession);
export default __webpack_public_path__ + "static/media/cash_in_session.6bf1ee52e88fbb83e561a43b9f1aca6e.svg";
export { ForwardRef as ReactComponent };